/** Diferencia ausencia definitiva de uma falha transitoria da API. */
export const isMissingHttpError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  const candidate = error as {
    isAxiosError?: boolean;
    response?: { status?: number };
  };
  if (candidate.isAxiosError !== true) return false;
  return candidate.response?.status === 404 || candidate.response?.status === 410;
};
